export default "__VITE_ASSET__BwGRwZYX__"